import { render, staticRenderFns } from "./DaftarProduk.vue?vue&type=template&id=22fe1205&scoped=true&"
import script from "./DaftarProduk.vue?vue&type=script&lang=js&"
export * from "./DaftarProduk.vue?vue&type=script&lang=js&"
import style0 from "./DaftarProduk.vue?vue&type=style&index=0&id=22fe1205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe1205",
  null
  
)

export default component.exports